// extracted by mini-css-extract-plugin
export var arc = "Hero-module--arc--fc754";
export var arrowUpAndDown = "Hero-module--arrow-up-and-down--f8e1a";
export var backgroundImage = "Hero-module--backgroundImage--a52e6";
export var backgroundImageContainer = "Hero-module--backgroundImageContainer--89948";
export var backgroundVideo = "Hero-module--backgroundVideo--44705";
export var backgroundVideoContainer = "Hero-module--backgroundVideoContainer--660c4";
export var bottomSpacing = "Hero-module--bottomSpacing--bd2fb";
export var button = "Hero-module--button--cf901";
export var buttonsContainer = "Hero-module--buttonsContainer--93cc1";
export var container = "Hero-module--container--61826";
export var contentContainer = "Hero-module--contentContainer--51c42";
export var contentWrapper = "Hero-module--contentWrapper--b303f";
export var definition = "Hero-module--definition--b80a6";
export var desktop = "Hero-module--desktop--85053";
export var dictionarySection = "Hero-module--dictionarySection--a516d";
export var fallbackImageVisible = "Hero-module--fallbackImageVisible--4db79";
export var form = "Hero-module--form--94a00";
export var fullHeight = "Hero-module--fullHeight--e55e8";
export var imageContainer = "Hero-module--imageContainer--46dc8";
export var link = "Hero-module--link--61158";
export var linksContainer = "Hero-module--linksContainer--e6a91";
export var mobile = "Hero-module--mobile--e01b3";
export var name = "Hero-module--name--eb7ce";
export var narrowText = "Hero-module--narrowText--8a86f";
export var onlyText = "Hero-module--onlyText--2c5a9";
export var overlay = "Hero-module--overlay--60296";
export var pronunciation = "Hero-module--pronunciation--739ad";
export var pronunciationAndLabel = "Hero-module--pronunciationAndLabel--537f6";
export var subtitle = "Hero-module--subtitle--6f834";
export var text = "Hero-module--text--0752e";
export var textContainer = "Hero-module--textContainer--d59bd";
export var textRight = "Hero-module--textRight--87b25";
export var textWrapper = "Hero-module--textWrapper--6aa35";
export var title = "Hero-module--title--044fe";
export var topSpacing = "Hero-module--topSpacing--38ccf";
export var video = "Hero-module--video--c0337";
export var videoAndLinksContainer = "Hero-module--videoAndLinksContainer--b2a81";
export var videoHidden = "Hero-module--videoHidden--f2433";
export var withBackgroundImage = "Hero-module--withBackgroundImage--b4af4";